module.exports = __webpack_public_path__ + "img/HZ-T1496.c0edbf91.jpg";